__turbopack_context__.v({
  "balanceCard": "BuzzTopUpCard-module-scss-module__WFrzvG__balanceCard",
  "bannerCard": "BuzzTopUpCard-module-scss-module__WFrzvG__bannerCard",
  "bannerTitle": "BuzzTopUpCard-module-scss-module__WFrzvG__bannerTitle",
  "benefitsList": "BuzzTopUpCard-module-scss-module__WFrzvG__benefitsList",
  "topUpBadge": "BuzzTopUpCard-module-scss-module__WFrzvG__topUpBadge",
  "topUpButton": "BuzzTopUpCard-module-scss-module__WFrzvG__topUpButton",
  "topUpCard": "BuzzTopUpCard-module-scss-module__WFrzvG__topUpCard",
  "topUpIcon": "BuzzTopUpCard-module-scss-module__WFrzvG__topUpIcon",
  "topUpTitle": "BuzzTopUpCard-module-scss-module__WFrzvG__topUpTitle",
});
